import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "flex items-center justify-center gap-x-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-20px line-through text-gray-lp-600"
}
const _hoisted_4 = { class: "font-semibold text-24px text-gray-lp-300" }
const _hoisted_5 = { class: "mt-4 font-normal text-gray-lp-300 text-14px" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" untuk STT ")
const _hoisted_8 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.textSubHeader)
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.textSubHeader), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.textHeader), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "sub-header", {}, () => [
        (_ctx.billType === 'booking')
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.sttNumber), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}